/**
 * Deployment environment detection.
 *
 * `import.meta.env.DEV` is only true for the local Vite dev server — every deployed
 * build (staging `dev-vamos` and production `main-vamos` alike) runs a plain `vite build`,
 * where `DEV` is always false. To tell staging apart from production, the deploy script
 * must set `VITE_APP_ENV=staging` (dev-vamos) at build time; if it's missing entirely,
 * this defaults to production behaviour rather than risking a real prod build hitting the
 * test gateway.
 */
const IS_STAGING_DEPLOY = import.meta.env.VITE_APP_ENV === 'staging';

/** True for local `yarn dev` and for the staging (dev-vamos) deployment. */
export const IS_DEV_GATEWAY = import.meta.env.DEV || IS_STAGING_DEPLOY;

/**
 * Base origin for every gateway call (`/as`, `/pps`, `/ssc`, the SOAP player…).
 *
 * In local dev this is the RELATIVE `/api/gw` prefix, which `vite.config.ts`
 * proxies to `VITE_GATEWAY_ORIGIN` (default: the test gateway). Going through
 * the dev server rather than calling the gateway directly is what makes
 * `VITE_GATEWAY_ORIGIN=https://api.vamos-reisen.de` usable: the production
 * gateway's CORS allowlist only accepts `https://www.vamos-reisen.de`, so a
 * direct browser call from localhost is blocked, while the proxy hop happens
 * server-side where CORS does not apply.
 *
 * Deployed builds keep calling the gateway directly — there is no dev server.
 */
export const GATEWAY_ORIGIN = import.meta.env.DEV
  ? '/api/gw'
  : IS_STAGING_DEPLOY
    ? 'https://vamos-api.asiososys.com'
    : 'https://api.vamos-reisen.de';
